export enum SearchProvider {
    AmazonCloudSearchProvider = "AmazonCloudSearchProvider",
    NfpaAiSearchProviderV2 = "NfpaAiSearchProviderV2",
}
